import { render, staticRenderFns } from "./RoleDepartment.vue?vue&type=template&id=5753de72&scoped=true"
import script from "./RoleDepartment.vue?vue&type=script&lang=js"
export * from "./RoleDepartment.vue?vue&type=script&lang=js"
import style0 from "./RoleDepartment.vue?vue&type=style&index=0&id=5753de72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5753de72",
  null
  
)

export default component.exports